<script setup lang="ts">
/**
 * A glossary.
 *
 * A description list, because that is what it is: the markup says term and
 * definition, so a screen reader and an export both read the pairing rather
 * than two unrelated runs of text.
 */
import type { GlossarySection } from '@/domain/section'

defineProps<{ section: GlossarySection }>()
</script>

<template>
  <section class="glossary">
    <dl class="glossary__list">
      <template v-for="entry in section.entries" :key="entry.id">
        <dt class="glossary__term">{{ entry.term }}</dt>
        <dd class="glossary__definition">{{ entry.definition }}</dd>
      </template>
    </dl>
  </section>
</template>

<style scoped>
.glossary__list {
  margin: 0.6em 0 1em;
}

.glossary__term {
  font-weight: 600;
  break-after: avoid;
}

.glossary__definition {
  margin: 0.15em 0 0.7em;
  padding-left: 1.2em;
  color: var(--paper-ink);
  text-align: justify;
  hyphens: auto;
}
</style>
